import { css, jsx } from '@emotion/core';
import { Icon } from 'antd';
import moment from 'moment';
import Link from 'next/link';
import React from 'react';

import { bp, colors } from '@/styles';

const style = {
  listContainer: fullWidth => css`
    display: flex;
    background-color: ${colors.white};
    max-width: ${fullWidth ? '100%' : '768px'};
    width: 100%;
    padding: 2rem 1.5rem 2rem 1.5rem;
    box-shadow: 0 6px 12px 0 rgba(35, 32, 32, 0.1);
    border-radius: 4px;
    &:hover {
      font-weight: bold;
      box-shadow: 0 11px 12px 0 rgba(35, 32, 32, 0.15);
      transform: translateY(-1px);
    }
    @media ${bp.md} {
      min-width: 70rem;
      max-width: 120.8rem;
    }
    margin: 0 auto;
    flex-direction: column;
  `,
  cardTextContainer: css`
    width: 100%;
    p {
      margin-bottom: 0;
    }
  `,
  cardSideContainer: css`
    justify-content: center;
    align-items: center;
    display: none;
    @media ${bp.md} {
      display: flex;
    }
    @media print {
      display: block;
      width: auto;
    }
  `,
  subject: css`
    font-size: 1.6rem;
    color: ${colors.secondaryBlue};
    @media print {
      font-size: 2.6rem;
    }
  `,
  cardIconRight: css`
    font-size: 2.4rem;
    color: ${colors.secondaryBlue};
    @media print {
      display: none;
    }
  `,
  wrapper: css`
    @media ${bp.md} {
      display: flex;
    }
  `,
  divinner: {
    container: css`
      width: 100%;
      display: block;
      margin-bottom: -16px !important;
      @media ${bp.md} {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
      }
    `,
    smContainer: css`
      display: block;
      margin-left: auto;
      margin-right: auto;
      padding-left: 16px;
      padding-right: 16px;
      max-width: 800px;
      @media ${bp.md} {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
      }
    `,
    topspacing: css`
      margin-top: 3.6rem;
    `,
    lhs: css`
      flex: 1;
      @media ${bp.sm} {
        margin-right: 32px;
      }
      @media print {
        margin-right: 0;
      }
    `,
    rhs: css`
      flex: 0 0 auto;
      max-width: 3rem;
      .ant-btn-group {
        @media print {
          display: none;
        }
      }
    `,
    full: css`
      clear: both;
      flex: 1;
      margin-bottom: 16px;
      width: 100%;
      @media ${bp.sm} {
        margin-right: 0px;
      }
      @media print {
        margin-right: 0;
      }
    `,
    buttonGroup: css`
      display: flex;
      justify-content: center;
      margin: 0 0 2.4rem;
      @media ${bp.md} {
        display: block;
      }
    `,
    note: css`
      font-size: 1.2rem;
    `,
    grayborder: css`
      background-color: #f6f5f5;
      border-bottom: solid 1px #dad9d7;
      border-top: solid 1px #dad9d7;
    `,
    center: css`
      text-align: center;
    `,
    right: css`
      text-align: right;
    `,
    bottom: css`
      margin: 3.6rem 0 0;
    `,
  },
};

function getFormatedDate(date) {
  const newDateFormat = moment(date);
  return newDateFormat.format('MM/DD/YYYY');
}

const communication = ({ data }) => {
  const { ImageFolderName } = data;

  return (
    <Link
      href="/about/leadership/ceo-communications/[slug]"
      as={`/about/leadership/ceo-communications/${ImageFolderName}`}
    >
      <a css={style.listContainer}>
        <div css={style.wrapper}>
          <div css={style.divinner.lhs}>
            <div>{getFormatedDate(data.CompletionDate)}</div>
            <p css={style.subject}>{data.Subject}</p>
          </div>
          <div css={[style.divinner.rhs, style.cardSideContainer]}>
            <Icon css={style.cardIconRight} type="right" />
          </div>
        </div>
      </a>
    </Link>
  );
};

export default communication;
